/**
 * Same-host redirect to /login. Earlier this hopped to app.<domain>
 * because the auth flow lived on a separate host; after the migration
 * everything is served from the same origin.
 */
export function redirectToLogin() {
  if (typeof window === 'undefined') return;
  window.location.href = '/login';
}
